/*
 * @Author:
 * @Description:
 * @Date: 2024-10-10 15:41:57
 * @LastEditors: Please set LastEditors
 * @FilePath: /rhcn-merchant-web/src/views/transaction/api/appeal-manage.service.js
 */

import Http from '@/utils/http/index';

export default {
  /**
   * 拒付查询列表
   */
  getChargebackList(params) {
    const obj = {
      ...params,
    };
    if (obj.chargebackStatus && (typeof obj.chargebackStatus === 'object') && obj.chargebackStatus.length) {
      obj.chargebackStatus = obj.chargebackStatus.join(',');
    }
    return Http.get('/chargeback/listChargeback', { params: obj });
  },

  downloadChargeback(params) {
    const obj = {
      ...params,
    };
    if (obj.chargebackStatus && (typeof obj.chargebackStatus === 'object') && obj.chargebackStatus.length) {
      obj.chargebackStatus = obj.chargebackStatus.join(',');
    }
    return Http.get('/chargeback/merchantListChargebackDownload', { params: obj });
  },

  /**
   * 拒付查询详情
   */
  getChargebackInfo(id) {
    const params = { id, isHistory: '1' };
    return Http.get('/chargeback/info', { params });
  },

  /**
   * 申诉文件上传
   */
  uploadAppealFile(file) {
    const param = new FormData(); // 创建form对象
    param.append('file', file);
    return Http.post('/chargeback/appealFileUpload', param, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },

  /**
   * 申诉提交
   */
  postSubmitAppeal(params) {
    return Http.post('/chargeback/appeal', params);
  },

  /**
   * 申诉提交-暂存
   */
  draftSubmitAppeal(params) {
    return Http.post('/merchant/chargeback/saveAppealInfoDraft', params);
  },
  /**
   * 申诉新增提交
   */
  postSupplementAppeal(params) {
    return Http.post('/chargeback/appealFileAdd', params);
  },
  /**
   * 接受拒付请求
   */
  postAcceptAppeal(params) {
    return Http.post('/chargeback/chargebackAccept', params);
  },

  /**
   * 提交抗辩
   */
  saveAppealInfoDraft(params) {
    return Http.post('/merchant/chargeback/saveAppealInfoDraft', params);
  },
  /**
   * 抗辩文件 全部下载
   */
  chargebackDownloadAll(params) {
    return Http.get('/merchant/chargeback/downloadAllFile', { params });
  },

};
